export enum ValidationMode {
  Current = 'CURRENT',
  Next = 'NEXT',
  None = 'NONE'
}
